<template>
  <vs-popup
    v-bind="$attrs"
    :active="active"
    @update:active="updateActive"
    @close="$emit('close')"
  >
    <slot></slot>
  </vs-popup>
</template>

<script>
export default {
  name: 'MainModal',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  beforeDestroy() {
    this.$el.style.display = 'none';
  },
  methods: {
    updateActive(value) {
      this.$emit('update:active', value);
    },
  },
};
</script>
